import { Survey } from '@verv-inc/js-questionnaire';
import { action, computed, makeObservable, observable, reaction } from 'mobx';

export class SurveyStore extends Survey {
	constructor() {
		super();
		makeObservable(this, {
			steps: observable,
			currentStep: observable,
			setSteps: action.bound,
			setAnswer: action.bound,
			goNext: action.bound,
			setQuestionCompleted: action.bound,
			setCurrentStep: action.bound,
			checkQuestionsCompleted: action.bound,
			answers: computed,
			nextStep: computed,
			currentStepQuestionsCompleted: computed,
			currentStepIndex: computed,
			surveyLength: computed,
		});

		reaction(
			() => JSON.stringify(this.answers),
			() => this.checkQuestionsCompleted(),
		);
	}
}
